import { render, staticRenderFns } from "./PendingPractitionerComplaints.vue?vue&type=template&id=5593e4e8&scoped=true&"
import script from "./PendingPractitionerComplaints.vue?vue&type=script&lang=js&"
export * from "./PendingPractitionerComplaints.vue?vue&type=script&lang=js&"
import style0 from "./PendingPractitionerComplaints.vue?vue&type=style&index=0&id=5593e4e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5593e4e8",
  null
  
)

export default component.exports